import { TabData } from './types';

export const TABS_DATA: TabData[] = [
  { label: "推薦人", value: 0 },
  { label: "申請人", value: 1 },
  { label: "NEX Work", value: 2 },
];

export const DEFAULT_MESSAGE = "目前沒有相關常見問題";
